var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "footer", staticClass: "footer-frame" },
    [
      _vm.isPhoneSize
        ? _c("div", { staticClass: "contact-fbg" }, [
            _c("div", { staticClass: "h1" }, [_vm._v("联系我们")]),
            _vm._v(" "),
            _c("div", { staticClass: "contact-k" }, [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "a",
                {
                  attrs: { href: "javascript:;" },
                  on: { click: _vm.weixinLink }
                },
                [
                  _c("img", {
                    staticStyle: { height: "18px" },
                    attrs: {
                      src: require("../assets/images/newhome/f07.png"),
                      alt: ""
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _vm._m(1),
              _vm._v(" "),
              _vm._m(2),
              _vm._v(" "),
              _vm._m(3),
              _vm._v(" "),
              _vm._m(4)
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "foot-w clearfix" }, [
        _c("img", {
          staticClass: "logo",
          attrs: { src: require("../assets/images/newlogo/logoz.svg"), alt: "" }
        }),
        _vm._v(" "),
        !_vm.isPhoneSize
          ? _c("ul", [
              _c("li", [
                _c(
                  "a",
                  { staticClass: "left", attrs: { href: "javascript:;" } },
                  [_vm._v("品牌与服务")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "left",
                    attrs: { href: "javascript:;" },
                    on: { click: _vm.wikiLink }
                  },
                  [_vm._v("虫害百科")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "left",
                    attrs: { href: "javascript:;" },
                    on: { click: _vm.sqLink }
                  },
                  [_vm._v("虫虫社区")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "left",
                    attrs: { href: "javascript:;" },
                    on: { click: _vm.weixinLinkzx }
                  },
                  [_vm._v("个人中心")]
                )
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "contact" }, [
                _c("div", { staticClass: "h1" }, [_vm._v("联系我们")]),
                _vm._v(" "),
                _c("div", { staticClass: "contact-k" }, [
                  _c("img", {
                    staticClass: "wxcode",
                    attrs: {
                      src: require("../assets/images/newhome/wx_qrcode.png"),
                      alt: ""
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "rt" }, [
                    _c(
                      "a",
                      {
                        attrs: { href: "javascript:;" },
                        on: { click: _vm.weixinLink }
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("../assets/images/newhome/bf07.png"),
                            alt: ""
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _vm._m(5),
                    _vm._v(" "),
                    _vm._m(6),
                    _vm._v(" "),
                    _vm._m(7),
                    _vm._v(" "),
                    _vm._m(8),
                    _vm._v(" "),
                    _vm._m(9)
                  ])
                ])
              ])
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "foot" }, [
        _c("div", { staticClass: "foot-w" }, [
          _c(
            "a",
            {
              attrs: {
                id: "footer_a_linkRouter_12",
                href: "https://www.byepest.com/terms"
              },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.linkRouter("/terms")
                }
              }
            },
            [_vm._v("服务协议")]
          ),
          _vm._v(" "),
          _vm.isPhoneSize ? _c("span", [_vm._v("|")]) : _vm._e(),
          _vm._v(" "),
          _c(
            "a",
            {
              attrs: {
                id: "footer_a_linkRouter_13",
                href: "https://www.byepest.com/privacy"
              },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.linkRouter("/privacy")
                }
              }
            },
            [_vm._v("个人信息保护政策")]
          ),
          _vm._v(" "),
          _vm.isPhoneSize ? _c("span", [_vm._v("|")]) : _vm._e(),
          _vm._v(" "),
          _c(
            "a",
            {
              attrs: {
                id: "footer_a_linkRouter_13",
                href: "https://beian.miit.gov.cn"
              }
            },
            [_vm._v("网站备案声明")]
          ),
          _vm._v(" "),
          _c("span", { staticClass: "mr" }, [
            _vm._v("© 2018 安蔚优环境科技（上海）有限公司 版权所有"),
            _vm.isPhoneSize ? _c("br") : _vm._e(),
            _vm._v("沪ICP备2022022077号-1")
          ]),
          _c("span", [_vm._v("上海市静安区昌平路363号1幢4层04-115室")])
        ])
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "weixin-dialog-img",
          attrs: { title: "", top: "20vh", visible: _vm.weixinDialogImg },
          on: {
            "update:visible": function($event) {
              _vm.weixinDialogImg = $event
            }
          }
        },
        [
          _vm.codeImg == ""
            ? _c("div", { staticClass: "con" }, [
                _c("img", {
                  directives: [
                    {
                      name: "lazy",
                      rawName: "v-lazy",
                      value: require("@/assets/images/newhome/404.png"),
                      expression: "require('@/assets/images/newhome/404.png')"
                    }
                  ],
                  staticStyle: { width: "50%", height: "auto" }
                }),
                _vm._v(" "),
                _c("p", { staticStyle: { color: "#4D4CC1" } }, [
                  _vm._v("服务即将上线，敬请期待")
                ])
              ])
            : _c("div", { staticClass: "con" }, [
                _c("img", {
                  directives: [
                    {
                      name: "lazy",
                      rawName: "v-lazy",
                      value: require("@/assets/images/newhome/" +
                        _vm.codeImg +
                        ".png"),
                      expression:
                        "require('@/assets/images/newhome/' + codeImg + '.png')"
                    }
                  ]
                }),
                _vm._v(" "),
                _c("p", [_vm._v("请微信扫码查看相关详情")])
              ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("span", [
        _c("img", {
          attrs: { src: require("../assets/images/newhome/bf02.svg"), alt: "" }
        }),
        _vm._v("byepest@envu.com")
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "ml" }, [
        _c("img", {
          attrs: { src: require("../assets/images/newhome/bf01.svg"), alt: "" }
        }),
        _vm._v("400-188-8282")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      { attrs: { href: "https://weibo.com/u/6753773401", target: "_blank" } },
      [
        _c("img", {
          staticStyle: { height: "18px" },
          attrs: { src: require("../assets/images/newhome/f06.png"), alt: "" }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        attrs: {
          href: "https://v.douyin.com/i8awfnsd/ 8@3.com",
          target: "_blank"
        }
      },
      [
        _c("img", {
          staticStyle: { height: "18px" },
          attrs: { src: require("../assets/images/newhome/f05.png"), alt: "" }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        attrs: {
          href: "https://www.zhihu.com/org/bai-er-chong-chong-bai-bai",
          target: "_blank"
        }
      },
      [
        _c("img", {
          staticStyle: { height: "20px" },
          attrs: { src: require("../assets/images/newhome/f04.png"), alt: "" }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        attrs: {
          href:
            "https://www.xiaohongshu.com/user/profile/61307b320000000002019fcc?xhsshare=CopyLink&appuid=5b5214c711be102747b8f1f9&apptime=1703150384",
          target: "_blank"
        }
      },
      [
        _c("img", {
          staticStyle: { height: "18px" },
          attrs: { src: require("../assets/images/newhome/f03.png"), alt: "" }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      { attrs: { href: "https://weibo.com/u/6753773401", target: "_blank" } },
      [
        _c("img", {
          attrs: { src: require("../assets/images/newhome/bf06.png"), alt: "" }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        attrs: {
          href: "https://v.douyin.com/i8awfnsd/ 8@3.com",
          target: "_blank"
        }
      },
      [
        _c("img", {
          attrs: { src: require("../assets/images/newhome/bf05.png"), alt: "" }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        attrs: {
          href: "https://www.zhihu.com/org/bai-er-chong-chong-bai-bai",
          target: "_blank"
        }
      },
      [
        _c("img", {
          attrs: { src: require("../assets/images/newhome/bf04.png"), alt: "" }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        attrs: {
          href:
            "https://www.xiaohongshu.com/user/profile/61307b320000000002019fcc?xhsshare=CopyLink&appuid=5b5214c711be102747b8f1f9&apptime=1703150384",
          target: "_blank"
        }
      },
      [
        _c("img", {
          attrs: { src: require("../assets/images/newhome/bf03.png"), alt: "" }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("span", [
        _c("img", {
          attrs: { src: require("../assets/images/newhome/bf02.png"), alt: "" }
        }),
        _vm._v("byepest@envu.com")
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "ml" }, [
        _c("img", {
          attrs: { src: require("../assets/images/newhome/bf01.png"), alt: "" }
        }),
        _vm._v("400-188-8282")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-40ab164b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/.store/vue-loader@13.7.3/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40ab164b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/.store/vue-loader@13.7.3/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = null
// module chunks = 